module.exports = __webpack_public_path__ + "img/dog_located.85e188bf.png";